import { MmuDeviceProductGroup } from './models/device-product-group';
import { MmuDeviceType } from './models/device-type';


/**
 * Gets the translation key for a given device type or product group.
 * This string is used in translations.
 * @param {MmuDeviceProductGroup | MmuDeviceType} value
 * @param {string} fallback
 * @returns {string}
 */
export function getDeviceTypeTranslationKey(value: MmuDeviceProductGroup | MmuDeviceType, fallback = 'unknown'): string {
  switch (value) {
    case MmuDeviceProductGroup.WM:
    case MmuDeviceType.WM:
    case MmuDeviceType.SPWM:
    case MmuDeviceType.PWM:
      return 'wm';
    case MmuDeviceProductGroup.TD:
    case MmuDeviceType.TD:
    case MmuDeviceType.SPTD:
    case MmuDeviceType.PTD:
      return 'td';
    case MmuDeviceProductGroup.DW:
    case MmuDeviceType.DW:
    case MmuDeviceType.SPDW:
    case MmuDeviceType.PDW:
      return 'dw';
    case MmuDeviceType.PWD_SLIMLINE:
    case MmuDeviceType.PWD_K23:
      return 'wd-lab';
    case MmuDeviceType.PWD_K23_LAB:
      return 'wd-k23-lab';
    case MmuDeviceType.PWD_K23_MED:
      return 'wd-k23-med';
    case MmuDeviceType.PWD_K23_FIRE:
      return 'wd-k23-fire';
    case MmuDeviceProductGroup.WD:
    case MmuDeviceType.PWD:
      return 'wd';
    case MmuDeviceProductGroup.ST:
    case MmuDeviceType.STEAM_STERILIZER_CUBE:
    case MmuDeviceType.STEAM_STERILIZER_CUBE_OLD:
      return 'st';
    default:
      return fallback;
  }
}

/**
 * Gets the icon name for a given device type or product group within the miele-icons-custom font.
 * See packages/styles/src/custom-font/README.md for more information how to update the icons within the font.
 * @param {MmuDeviceProductGroup | MmuDeviceType} value
 * @param {string} fallback icon
 * @returns {string} The icon name within the font
 */
export function getDeviceTypeIconName(value: MmuDeviceProductGroup | MmuDeviceType, fallback = 'question'): string {
  switch (value) {
    case MmuDeviceProductGroup.WM:
    case MmuDeviceType.WM:
    case MmuDeviceType.SPWM:
    case MmuDeviceType.PWM:
      return 'wm'; // Washing machine: Circle with single horizontal wave inside
    case MmuDeviceProductGroup.TD:
    case MmuDeviceType.TD:
    case MmuDeviceType.SPTD:
    case MmuDeviceType.PTD:
      return 'td'; // Tumble dryer: Circle with some wavy lines inside
    case MmuDeviceProductGroup.DW:
    case MmuDeviceType.DW:
    case MmuDeviceType.SPDW:
    case MmuDeviceType.PDW:
      return 'dw'; // Dishwasher: Glass with drop
    case MmuDeviceType.PWD_SLIMLINE:
    case MmuDeviceType.PWD_K23:
    case MmuDeviceType.PWD_K23_LAB:
      return 'wd-lab'; // Washer-disinfector: Erlenmeyer flask
    case MmuDeviceType.PWD_K23_MED:
      return 'wd'; // Medical washer-disinfector: Medical "cross" icon
    case MmuDeviceType.PWD_K23_FIRE:
      return 'fire-helmet'; // Fire brigade washer-disinfector: Fire helmet
    case MmuDeviceProductGroup.WD:
    case MmuDeviceType.PWD:
      return 'pwd'; // Generic washer-disinfector: outline of fuge machine
    case MmuDeviceProductGroup.ST:
    case MmuDeviceType.STEAM_STERILIZER_CUBE:
    case MmuDeviceType.STEAM_STERILIZER_CUBE_OLD:
      return 'st'; // Steam sterilizer: Shield with bacteria inside
    default:
      return fallback;
  }
}
